import axios from "axios";
import { isEmbedded } from "@/lib/integration";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "rgpd_token";

const api = axios.create({ baseURL: API });

let accessToken = isEmbedded ? null : localStorage.getItem(TOKEN_KEY);
let renewSession = null;

export function setAccessToken(token) {
  accessToken = token;
  if (isEmbedded) return;
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export const getAccessToken = () => accessToken;

export function onSessionExpired(handler) {
  renewSession = handler;
}

api.interceptors.request.use((config) => {
  if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
  return config;
});

api.interceptors.response.use(undefined, async (error) => {
  const { config, response } = error;
  if (!isEmbedded || !renewSession || response?.status !== 401 || config._renewed) throw error;
  config._renewed = true;
  await renewSession();
  return api(config);
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
